import type { RouteType } from "types/RouteType";
import { gateBillingRoutes } from "./billingGate";
import invoicesRoute from "./Invoices/invoices.Route";
import recurringRoute from "./Recurring/recurring.Route";
import receivablesRoute from "./Receivables/receivables.Route";

/**
 * Every billing route passes through gateBillingRoutes, so adding one here
 * cannot accidentally ship an ungated financial page.
 */
const billingRoutesList: RouteType[] = gateBillingRoutes([...invoicesRoute, ...recurringRoute, ...receivablesRoute]);

export default billingRoutesList;
